import React from 'react';
import { Box, Checkbox, Tooltip } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import IconButton from '@material-ui/core/IconButton';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CloseIcon from '@material-ui/icons/Close';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import CmtAvatar from 'components/@coremat/CmtAvatar';
import AppTextInput from 'components/@jumbo/components/Common/formElements/AppTextInput';
import AddSubTaskMedarr from './AddSubTaskMedarr';
import {Avatar} from '@material-ui/core'
import { upperCase, isEmpty } from 'lodash';
import { injectIntl, defineMessages } from 'react-intl';
const useStyles = makeStyles(theme => ({
  subTaskCelItem: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: fade(theme.palette.common.dark, 0.05),
    borderRadius: 4,
    marginBottom: 1,
    marginTop: 1,
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      flexDirection: 'row',
    },
  },
  textFieldRoot: {
    marginLeft: 6,
    width: '100%',
    '& .MuiInput-underline': {
      '&:before': {
        display: 'none',
      },
    },
  },
  imgRoot: {
    borderRadius: '50%',
    display: 'block',
  },
  assignAvatar:{
    ['&:hover']: {
      cursor: 'pointer'
    }
  }
}));

const SubTaskCell = ({intl, data, index, onChange, removeSubTask, onSubTaskAssign, onComplete }) => {
  const classes = useStyles();
  const placeholder = intl.formatMessage({ id: 'sidebar.appModule.toDo1' });
  const RemoveLabel = intl.formatMessage({ id: 'Remove' });
  return (
    <Box className={clsx(classes.subTaskCelItem, 'subtask-cellitem')}>
      <Box flex={1} display="flex" alignItems="center">
        <Checkbox 
          color="primary" 
          icon={<RadioButtonUncheckedIcon />} 
          checkedIcon={<RadioButtonCheckedIcon />} 
          checked={data.completed}  
          onChange={(e) => onComplete(e.target.checked, index)}
        />
        <AppTextInput
          id="standard-basic"
          multiline
          className={classes.textFieldRoot}
          placeholder={placeholder}
          defaultValue={data.title}
          onChange={e => onChange(e.target.value, index)}
        />
      </Box>
      <Box ml={2} display="flex" alignItems="center">
        {data.assignTo ? (
          <Box mr={2}>
            <Tooltip title={`${RemoveLabel} ${data.assignTo.FirstName} ${data.assignTo.LastName}`}>
              <Avatar 
                style={{ fontSize: '12px', margin: 'auto' }} 
                // className="bg-blue darken-3 text-white size-30" 
                src={data.assignTo.ProfilePicUrl} 
                onClick={() => onSubTaskAssign([], index)}
                className={`${classes.assignAvatar} bg-blue darken-3 text-white size-30`}
              >
                { upperCase(data.assignTo.FirstName[0])}
                { isEmpty(data.assignTo.LastName)?"":upperCase(data.assignTo.LastName[0])}
              </Avatar>
              {/* <CmtAvatar
                onClick={() => onSubTaskAssign([], index)}
                className={classes.imgRoot}
                src={data.assignTo.profilePic}
                size={35}
                alt={data.assignTo.name}
              /> */}
            </Tooltip>
          </Box>
        ) : (
          <AddSubTaskMedarr collaborators={data.collaborators} complete={(arr) => onSubTaskAssign(arr, index)}/>
        )}
        <IconButton onClick={() => removeSubTask(data)}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default injectIntl(SubTaskCell);
